import { formatLedgerWhen, formatSitePlot } from "../format";
import { RefCode } from "../primitives";
import type { LedgerCells } from "../types";
import { BookedWorkCell } from "./columnKeys";

/** Where a piece of work happened. The site truncates, the plot never does. */
export interface SitePlot {
  site: string;
  /** Absent on a row scoped to the whole site rather than to one plot. */
  plot?: string | null;
}

export interface WorkCellData {
  reference?: string | null;
  bookedBy?: string | null;
  /** ISO timestamp. */
  bookedAt?: string | null;
  sitePlot?: SitePlot;
}

/** Builds the standard booked-work cell map; screens choose which to show. */
export function workCells({
  reference,
  bookedBy,
  bookedAt,
  sitePlot,
}: WorkCellData): LedgerCells {
  return {
    [BookedWorkCell.Ref]: reference ? <RefCode>{reference}</RefCode> : null,
    [BookedWorkCell.BookedBy]: bookedBy ?? null,
    [BookedWorkCell.When]: bookedAt ? formatLedgerWhen(bookedAt) : null,
    [BookedWorkCell.SitePlot]: sitePlot
      ? formatSitePlot(sitePlot.site, sitePlot.plot)
      : null,
  };
}
